import { AnimatePresence, motion } from "framer-motion"
import styled from "styled-components"

const Background = styled(motion.div)`
  position: fixed;
  bottom: 0;
  left: 0;
  height: 4px;
  width: 100%;
  background: #707070;
`

const ProgressIndicator = styled.div.attrs(({ progress }) => ({
  style: {
    transform: `scaleX(${progress}`,
  },
}))`
  width: 100%;
  height: 100%;
  background: #fdca00;
  transform-origin: left;
`

const animations = {
  variants: {
    visible: {
      opacity: 1,
      y: 0,
      transition: { delay: 1 },
    },
    hidden: {
      opacity: 0,
      y: 10,
      transition: {
        delay: 0,
        ease: "easeOut",
      },
    },
  },

  initial: "hidden",
  animate: "visible",
  exit: "hidden",
}

const ProgressBar = ({ progress = 0, isVisible = true }) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <Background key={"Progressbar"} {...animations}>
          <ProgressIndicator progress={progress} />
        </Background>
      )}
    </AnimatePresence>
  )
}

export default ProgressBar
